import { ReactNode, useContext } from 'react';
import { Permission, Permissions } from '../constants/permissionsConstants';
import { PermissionsContext } from '../contexts/PermissionsProvider';

type PermissionSwitcherProps = {
  children: ReactNode;
  authorizations?: Permissions | Permissions[];
  clusterAuthorization?: Permission | Permission[];
  action?: Permission | Permission[];
};

export function PermissionSwitcher({
  children,
  authorizations,
  action,
  clusterAuthorization,
}: PermissionSwitcherProps) {
  const { satisfies } = useContext(PermissionsContext);
  if (satisfies({ authorizations, action, clusterAuthorization })) {
    return children;
  }
  return null;
}
